import React from "react";
import { Container } from "@mui/material";
import GarpacReportsContainer from "./GarpacReportsContainer";

const FailureTrackingReports = () => {
  return (
    <Container maxWidth={false} disableGutters sx={{ width: "100%", maxWidth: "none", p: 0 }}>
      <GarpacReportsContainer defaultTab="failure" />
    </Container>
  );
};

export default FailureTrackingReports;
